// extracted by mini-css-extract-plugin
export default {"menu-button__custom-button":"menuButton_menu-button__custom-button__yPwa3"};